import { combineReducers } from 'redux';
import mediaLabCardFrameworkState from './media-lab-card-framework';
import smallCardFrameworkState from './small-card-framework';
import largeCardFrameworkState from './large-card-framework';
import smallImageCardState from './small-image-card';
import slideshowState from './slideshow';

export default combineReducers({
  mediaLabCardFrameworkState,
  smallCardFrameworkState,
  largeCardFrameworkState,
  smallImageCardState,
  slideshowState,
});



/** WEBPACK FOOTER **
 ** ./assets/js/src/reducers/index.js
 **/